import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUIStates,
  selectUser,
  setSelectedMenu,
  setSelectedMenuId,
  setUIStates,
} from "../../redux/features/appData/appDataSlice";
import "./AvatarMenu.css";
import "../../css/Icons.css";
import { MENUS } from "../config/menus";
import { iconPath } from "effno-core";

const AVATAR_MENU = {
  LOGOUT: "logout",
  PERSONAL: "personal",
  WORKSPACE: "workspace",
  MEDIA_MANAGER: "media_manager",
};

type AvatarMenuProps = {
  image: string;
};

export default function AvatarMenu({ image }: AvatarMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeUser = useSelector(selectUser);
  const uiStates = useSelector(selectUIStates);

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // no floaters on avatar menu pages
    dispatch(
      setUIStates({
        ...uiStates,
      })
    );

    // route it
    switch (selection) {
      case AVATAR_MENU.MEDIA_MANAGER:
        dispatch(setUIStates({ ...uiStates, mediaManagerOpen: true }));
        break;
      case AVATAR_MENU.PERSONAL:
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/settings");
        break;
      case AVATAR_MENU.WORKSPACE:
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/workspaces");
        break;
      case AVATAR_MENU.LOGOUT:
        navigate("/logout");
        break;
      default:
    }
  };

  return (
    <>
      <div className="avatar-image-and-name" onClick={handleButtonClick}>
        <div className="avatar-image">
          <img src={image} alt="" />
        </div>
        {/* <div className="avatar-name">
          {storeUser?.firstName} {storeUser?.lastName}
        </div> */}
        {/* <div className="avatar-caret">
          <img src={iconPath("down.svg", storeUser)} alt="" />
        </div> */}
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.MEDIA_MANAGER)}>
          Media Manager
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.WORKSPACE)}>
          Workspace Settings
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.PERSONAL)}>
          Personal Settings
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.LOGOUT)}>
          {/* <span style={{ color: "var(--text-color-error)" }}>Log Out</span> */}
          Log Out
        </MenuItem>
      </Menu>
    </>
  );
}
